import React, { useState } from "react";
import DashboardLayout from "examples/LayoutContainers/DashboardLayout";
import ResponsiveTabs from "components/StyledComponents/styledComponents";
import { StyledTableContainer } from "components/StyledComponents/styledComponents";
import FinancialSummary from "../../MISReports/ActualP&L/newP&LSummary";
import { Box, Container, Paper, Typography } from "@mui/material";
const ProfitAndLossReport = () => {
  const [activeTab, setActiveTab] = useState(0);
  const tabs = [{ label: "Estimated P & L" }, { label: "Actual P & L" }];
  const handleChange = (event, newValue) => {
    setActiveTab(newValue);
  };
  return (
    <DashboardLayout>
      <Box sx={{ pt: 2, width: "100%", px: 0 }}>
        <Paper
          sx={{
            borderRadius: 3,
            overflow: "hidden",
            width: "100%",
          }}
        >
          <ResponsiveTabs
            tabs={tabs}
            activeTab={activeTab}
            onChange={handleChange}
            labelColor="#ffffff"
            bgColor="#e0f7fa"
          />
          <Box sx={{ p: 0, backgroundColor: "#fff", width: "100%" }}>
            {activeTab === 0 && <FinancialSummary isKh={false} />}
            {activeTab === 1 && <FinancialSummary isKh={true} />}
          </Box>
        </Paper>
      </Box>
    </DashboardLayout>
  );
};

export default ProfitAndLossReport;
